<template>
    <div></div>
</template>

<script>
    export default {
        name: "redirect",
        data(){
            return{
            }
        },
        created(){
            this.jump()
        },
        computed:{

        },
        methods:{
            jump(){
                // console.log(111);
                let url=this.$route.query.url
                // console.log(url);
                let query=this.$route.query
                // console.log(query);
                this.$page.closeCurrent()
                this.$router.push({
                    ...query,
                    path:`${url}`,
                    // path:'/index'
                })


            }
        }
    }
</script>

<style scoped>

</style>
